import { gql } from '@apollo/client';
export const DASHBOARD_QUERY =  (from_date, to_date) => {
  return gql`
    query get_lead_count($leadCountInput: LeadCountInput!){
      get_lead_count(leadCountInput: $leadCountInput){
        data{
          type
          text
          color
          value
          is_show
          icon_className
          max_icon_paths
          filter_params{
            status_id
          }
          is_click
        }
      }
    }
  `;
};


export const MASTERDATA_QUERY =  () => {
  return gql`
  query($api_called_by:API_CALL_BY!,$master_data:[String!]){ 
    masterdata(api_called_by:$api_called_by,master_data:$master_data){
        make_year{
          label
          value
        }
        area_id{
          value
          label
        }
        document_list{
          id
          parent_id
          is_required
          is_required_app
          max_upload
          min_upload
          name
          child{
            id
            name
          }
        }
        region_city{
          state {
            id
            name
          }
          city {
            id
            name
            state_id
          }
        }
        inspection_attributes{
          id
          parent_id
          name
          max_score
          sort
          child{
            id
            parent_id
            name
            sort
            type
          }
        }   
      }
    }
  `;
};

export const GET_AREA_LIST_QUERY =  () => {
  return gql`
  query($api_called_by:API_CALL_BY!,$city_id:Int){ 
    area_list(api_called_by:$api_called_by,city_id:$city_id){
      id
      city_id
      name
      }
    }
  `;
};

export const GET_DEALER_LIST_QUERY =  () => {
  return gql`
  query($api_called_by:API_CALL_BY!,$area_id:Int){ 
    dealer_list(api_called_by:$api_called_by,area_id:$area_id){
      id
      name
      }
    }
  `;
};


export const GET_MMV_BY_YEAR =  () => {
  return gql`
  query($mmvByYearInput: MMVBYYearInput!){ 
    get_mmv_by_year(mmvByYearInput:$mmvByYearInput){
      make {
        id
        name
        make
        type
      }
      make_count
      model {
        id
        make_id
        name
        model
        type
      }
      model_count
      version {
        id
        make_id
        model_id
        name
        version
        type
      }
      version_count
      }
    }
  `;
};